var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
/** @jsx jsx */
import { jsx } from 'theme-ui';
export var FlexRow = function (_a) {
    var responsive = _a.responsive, space = _a.space, props = __rest(_a, ["responsive", "space"]);
    return (jsx("div", __assign({}, props, { sx: {
            display: 'flex',
            flexDirection: responsive ? ['column', 'row'] : 'row',
            alignItems: responsive ? ['flex-start', 'center'] : 'center',
            '& > :not(:first-of-type)': space
                ? {
                    ml: responsive
                        ? [0, Array.isArray(space) ? space[1] : space]
                        : space,
                    mt: responsive
                        ? [Array.isArray(space) ? space[0] : space, 0]
                        : space,
                }
                : {},
        } })));
};
//# sourceMappingURL=FlexRow.js.map